export default __webpack_public_path__ + "static/media/ic_frax_40.7e94b658.svg";